import r from"react";import e from"@mui/material/CircularProgress";const i=({size:i=20})=>r.createElement(e,{size:i,color:"inherit"});export{i as LoadSpinner};
//# sourceMappingURL=LoadSpinner.js.map
